import { APP_VERSION, isServer } from "./constant";
import { getMtAppVersion } from "./getBrowserEnv";
import { getUnionId } from "./userInfo";

export enum LogType {
  OWL = "owl",
  TRACKER = "tracker",
}

export enum LogLevel {
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

export function log({ msg, logType = LogType.OWL, logLevel = LogLevel.INFO, tags }: {
  msg: string;
  logType?: LogType;
  logLevel?: LogLevel;
  tags?: string[];
}) {
  if (isServer) return;
  if (window.Logan) {
    window.Logan.log(msg, logType, logLevel, tags);
  }
}

export function logInfo(msg: string, tags?: string[]) {
  log({ msg, logLevel: LogLevel.INFO, tags });
}

export function logWarn(msg: string, tags?: string[]) {
  log({ msg, logLevel: LogLevel.WARN, tags });
}

export function logError(msg: string, tags?: string[]) {
  log({ msg, logLevel: LogLevel.ERROR, tags });
}

/**
 * 统一上报日志
 */
export function reportLog() {
  if (isServer) return;
  if (window.Logan) {
    window.Logan.report(null, null, {
      unionId: `mtunionFxCenter|${getUnionId()}`,
      customReport: {
        platform: window.SYSTEM_PLATFORM || '',
        container: window.RUNTIME_CONTAINER || '',
        version: APP_VERSION,
        mtAppVersion: getMtAppVersion() || '',
        exp_group: window.FX_EXPERIMENT_INFO?.["exp_group"] || "other",
      },
    });
  }
}

// 上报模板中的缓存日志
if (!isServer && Array.isArray(window?.FX_LOG_CACHE)) {
  window.FX_LOG_CACHE.forEach(log);
}
